import {createApp} from 'vue'
import {createRouter, createWebHistory} from 'vue-router'
import MyApp from "@/pages/MyApp";
import App from "@/pages/App";
import MyBookings from "@/pages/MyBookings";
import {store} from "@/store/vuexStore";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueMitter from '@nguyenshort/vue3-mitt';
import VueMobileDetection from "vue-mobile-detection";
import VueCookies from 'vue3-cookies';


const   router = createRouter({
        routes: [
            {
                name: "schedule",
                path: '/schedule/',
                component: MyApp,
            },
            {
                name: "mybookings",
                path: '/schedule/mybookings',
                component: MyBookings
            },
            {
                name: "myarchive",
                path: '/schedule/mybookings/archive',
                component: MyBookings,
                props:{archive:true},
            },
            {
                name: "view",
                path: '/schedule/mybookings/view',
                component: MyApp,
                props:{mode:'view'},

            },
            {
                name: "index",
                // path: '/:city(\\w+)?/',
                path: '/:city([a-zA-Z\\-]+)?/',
                component: MyApp,
            }
        ],
        history: createWebHistory(),
        scrollBehavior() {
            return {
                // could also be
                // el: document.getElementById('main'),
                el: '#app',
                top: 67,
                behavior: 'smooth',
            }
        }
    })

// console.log(window.location.href.indexOf("schedule/"));

let inJsonEl = document.getElementById('searchData');
var searchDataForm = inJsonEl ? JSON.parse(inJsonEl.textContent) : {};
if (Object.keys(searchDataForm).length > 0){
    store.commit('setSearchDataForm', searchDataForm, {root: true})
}


const app = createApp(App)

app.use(VueMobileDetection);
app.use(VueCookies);
// const app = createApp(SimpleRouterApp)
// Install the store instance as a plugin
app.use(store)
app.use(VueMitter)
app.use(router)
app.use(Toast, {
    // timeout: false,
    // For the actual toast, including different toast types:
    hideProgressBar: true,
    toastClassName: "custom-toast-class",

    // For the toast body when using strings or a custom component as content
    // bodyClassName: ["custom-class-1", "custom-class-2"]
})


// app.use(VueCookies)
let indexApp = document.getElementById('indexApp');
// console.log('indexApp',indexApp)
if(indexApp){
    app.mount('#indexApp')
}else{
    app.mount('#app')
}





